import { Component } from '@angular/core'

@Component({
  selector: 'se-po-child-contact-info-docs',
  templateUrl: './child-contact-info-docs.component.html',
  styleUrls: ['./child-contact-info-docs.component.scss'],
  standalone: false,
})
export class ChildContactInfoDocsComponent {
  public models: string[]
  public headers: any = {
    ChildContactInfoComponent: [
      'Property',
      'Type',
      'Description',
    ],
    ChildContactInfoValueFields: [
      'Property',
      'Type',
      'Description',
    ]
  }
  public rows: any = {
    ChildContactInfoComponent: [
      {
        Property: '@Input() persona',
        Type: 'Persona',
        Description: 'Child\'s persona object',
      }
    ],
    ChildContactInfoValueFields: [
      {
        Property: 'email?',
        Type: 'string',
        Description: 'Email address for child contact'
      },
      {
        Property: 'phone?',
        Type: 'string',
        Description: 'Phone number for child contact'
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
